import { createContextProvider } from "../components/store-utils"
import { load } from "../loaders/basic-loader"
import { AccountChannelReport, ChannelReportEntry } from "./channel-models"

export interface ChannelReportState {
    data?: ChannelReportEntry[]
    sorter?: {id: string, asc: boolean}
    selected?: number
    filter?: string
    date?: string
}

export type ChannelAction = {type: "setData", data: ChannelReportEntry[]} |
{type: "numberSorter", id: string, getter: (r: ChannelReportEntry) => number} |
{type: "stringSorter", id: string, getter: (r: ChannelReportEntry) => string} |
{type: "select", selected: number} |
{type: "setDate", date: string};



function numberSorter(state: ChannelReportState, {id, getter}:{id: string, getter: (r: ChannelReportEntry) => number}){
    var data = [...state.data];
    var reverse = state.sorter?.id == id && state.sorter?.asc;
    data.sort((a, b) => getter(a) - getter(b))
    if(reverse)
        data.reverse();
    return {
        ...state,
        data,
        sorter: {id, asc: !reverse}
    }
}

function stringSorter(state: ChannelReportState, {id, getter}:{id: string, getter: (r: ChannelReportEntry) => string}){
    var data = [...state.data];
    var reverse = state.sorter?.id == id && state.sorter?.asc;
    data.sort((a, b) => getter(a)?.localeCompare(getter(b)))
    if(reverse)
        data.reverse();
    return {
        ...state,
        data,
        sorter: {id, asc: !reverse}
    }
}


function reducer(state: ChannelReportState, action: ChannelAction):ChannelReportState {
    switch(action.type){
        case "setDate": return {...state, date: action.date}
        case "setData" : return {...state, data: action.data};
        case "numberSorter": return numberSorter(state, {id: action.id, getter: action.getter});
        case "stringSorter": return stringSorter(state, {id: action.id, getter: action.getter});
        case "select": return {...state, selected: action.selected};
    }
    return state;
}

export const [ChannelContext, ChannelStore] = createContextProvider(reducer, {})

export async function loadChannelReport(period:string):Promise<ChannelReportEntry[]>{
    return await load("api/v1/channel-summary" + (period ? `?period=${period}` : '') )
}

export async function loadChannelReportByDate(date:string):Promise<ChannelReportEntry[]>{
    return await load("api/v1/channel-summary/" + date)
}

export async function loadChannelReportByAccount(account:number, period: string):Promise<AccountChannelReport>{
    return await load("api/v1/channel-report/" + account +  (period ? `?period=${period}` : ''))
}